import React from 'react';

import { isEmpty } from 'es-toolkit/compat';

import type { Nullable } from '@clearverify/types';

import { useGetActivityLogsListQuery } from 'src/api';
import { RESOURCES_INBOX_ITEM_ID } from 'src/constants/resources';

export const useActivityLogsByInboxItemId = (inboxItemId: Nullable<string>) => {
  const { data, loading } = useGetActivityLogsListQuery({
    variables: { inboxItemId: inboxItemId || '' },
    skip: !inboxItemId || inboxItemId === RESOURCES_INBOX_ITEM_ID,
    // change first execution fetchPolicy to ensure activityLogs are updated when unread inboxItem is opened
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    pollInterval: 10000,
  });

  // during refetch it resets activityLogs state to null resulting in glitching at ActivityLogsList
  // now it's null only for the first time to render skeleton during first load
  // and then being updated only once request is finished successfully

  const [activityLogs, setActivityLogs] = React.useState(data?.getActivityLogsList);

  React.useEffect(() => {
    if (!loading && Array.isArray(data?.getActivityLogsList)) {
      setActivityLogs(data.getActivityLogsList);
    }
  }, [loading, data?.getActivityLogsList]);

  return {
    activityLogs,
    loading: loading && isEmpty(activityLogs),
  };
};
